import styled from 'styled-components';

export const Clients = styled.section`
  padding: 180px 0 200px;

  @media (max-width: 990px) {
    padding: 90px 0;
  }

  @media (max-width: 767px) {
    padding: 20px 0 60px;
  }

  .clients-main {
    & > div {
      &:first-child {
        min-width: 90%;
        max-width: 90%;

        @media only screen and (max-width: 767px) {
          max-width: 100%;
        }
      }
    }
  }

  .client-block {
    position: relative;
    margin: 0 -7.5px;
    overflow: hidden;

    & > div {
      flex: 1;
      min-width: 100%;
      max-width: 100%;
      transition: all 0.5s;
    }

    .single-client {
      position: relative;
      height: 129px;
      width: calc(25% - 15px);
      margin: 0 7.5px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      margin-bottom: 15px;
      text-align: center;
      transition: 0.3s all;

      &.empty {
        border: 0;
        pointer-events: none;
      }

      @media (max-width: 990px) {
        width: calc(33% - 15px);
      }

      @media only screen and (max-width: 767px) {
        width: 44%;
        margin: 8px;
        height: 81px;
      }

      &::before {
        background-color: #ff4552;
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        content: '';
        transition: 0.3s all;
        z-index: 0;
        opacity: 0;
      }

      img {
        position: relative;
        max-height: 125px;
        max-width: 70%;
        padding: 42px 0;
        object-fit: contain;
        object-position: center;
        transition: 0.3s all;

        @media (max-width: 990px) {
          padding: 53px 0;
        }

        @media only screen and (max-width: 767px) {
          padding: 23px 0;
          max-height: 80px;
          max-width: 80%;
        }
      }

      &:hover {
        border: 1px solid rgba(255, 255, 255);

        &::before {
          top: -7px;
          right: -7px;
          opacity: 1;
        }

        img {
          transform: translate(3.5px, -3.5px);
        }
      }
    }
  }

  .rotated-tab-txt {
    left: auto;
    right: -210px;
    bottom: 50%;

    p::after {
      display: none;
    }
  }
`;
